<template>
  <div class="c-card">
    <div class="c-card__pill">page</div>
    <div class="c-card__liner">
      <div class="c-card__content">
        <div class="c-card__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49"
            height="50"
            viewBox="0 0 49 50"
            fill="none"
          >
            <path
              d="M12.25 6.98487V5.48487H10.75V6.98487H12.25ZM14.4795 43.2898L13.7985 44.6263H13.7985L14.4795 43.2898ZM12.695 41.5053L11.3585 42.1863H11.3585L12.695 41.5053ZM34.5205 7.42992L35.2014 6.09341V6.09341L34.5205 7.42992ZM36.3049 9.21441L34.9684 9.89539L34.9684 9.89539L36.3049 9.21441ZM13.75 39.6515C13.75 38.8231 13.0784 38.1515 12.25 38.1515C11.4216 38.1515 10.75 38.8231 10.75 39.6515H13.75ZM12.25 14.6099C13.0784 14.6099 13.75 13.9383 13.75 13.1099C13.75 12.2814 13.0784 11.6099 12.25 11.6099L12.25 14.6099ZM7.14583 13.1099L7.14583 11.6099L7.14583 13.1099ZM6.125 12.089L4.625 12.089L6.125 12.089ZM6.125 11.0682H7.625H6.125ZM16.3333 8.48486C17.1618 8.48486 17.8333 7.81329 17.8333 6.98486C17.8333 6.15644 17.1618 5.48486 16.3333 5.48486L16.3333 8.48486ZM10.2083 6.98486V8.48486V6.98486ZM35.25 13.5182V37.6099H38.25V13.5182H35.25ZM13.75 37.2015V6.98487H10.75V37.2015H13.75ZM18.375 42.2349C15.9546 42.2349 15.6422 42.1987 15.1605 41.9533L13.7985 44.6263C15.0638 45.271 16.2216 45.2349 18.375 45.2349V42.2349ZM10.75 37.2015C10.75 38.3202 10.7488 39.2495 10.8106 40.0056C10.8738 40.7793 11.0103 41.5029 11.3585 42.1863L14.0316 40.8243C13.9347 40.6343 13.8487 40.3495 13.8006 39.7613C13.7512 39.1557 13.75 38.3697 13.75 37.2015H10.75ZM15.1605 41.9533C14.6744 41.7056 14.2792 41.3104 14.0316 40.8243L11.3585 42.1863C11.8938 43.2369 12.748 44.091 13.7985 44.6263L15.1605 41.9533ZM30.2167 8.48487C31.3849 8.48487 32.1708 8.48603 32.7764 8.53552C33.3646 8.58357 33.6494 8.66961 33.8395 8.76643L35.2014 6.09341C34.518 5.74518 33.7944 5.60869 33.0207 5.54548C32.2646 5.4837 31.3354 5.48487 30.2167 5.48487V8.48487ZM38.25 13.5182C38.25 12.3995 38.2512 11.4703 38.1894 10.7141C38.1262 9.94046 37.9897 9.21686 37.6414 8.53342L34.9684 9.89539C35.0653 10.0854 35.1513 10.3703 35.1993 10.9584C35.2488 11.5641 35.25 12.35 35.25 13.5182H38.25ZM33.8395 8.76643C34.3256 9.01411 34.7208 9.40931 34.9684 9.89539L37.6414 8.53342C37.1062 7.48285 36.252 6.62871 35.2014 6.09341L33.8395 8.76643ZM30.2167 5.48487H12.25V8.48487H30.2167V5.48487ZM16.3333 45.2349H18.375V42.2349H16.3333V45.2349ZM19.875 43.7349V38.6307H16.875V43.7349H19.875ZM19.3958 39.1099H41.8542V36.1099H19.3958V39.1099ZM41.375 38.6307V39.6515H44.375V38.6307H41.375ZM38.7917 42.2349H18.375V45.2349H38.7917V42.2349ZM41.375 39.6515C41.375 41.0783 40.2184 42.2349 38.7917 42.2349V45.2349C41.8753 45.2349 44.375 42.7351 44.375 39.6515H41.375ZM41.8542 39.1099C41.5895 39.1099 41.375 38.8953 41.375 38.6307H44.375C44.375 37.2385 43.2464 36.1099 41.8542 36.1099V39.1099ZM19.875 38.6307C19.875 38.8953 19.6605 39.1099 19.3958 39.1099V36.1099C18.0036 36.1099 16.875 37.2385 16.875 38.6307H19.875ZM10.75 39.6515C10.75 42.7351 13.2497 45.2349 16.3333 45.2349V42.2349C14.9066 42.2349 13.75 41.0783 13.75 39.6515H10.75ZM12.25 11.6099L7.14583 11.6099L7.14583 14.6099L12.25 14.6099L12.25 11.6099ZM7.625 12.089L7.625 11.0682H4.625L4.625 12.089L7.625 12.089ZM16.3333 5.48486L10.2083 5.48486V8.48486L16.3333 8.48486L16.3333 5.48486ZM7.625 11.0682C7.625 9.64146 8.7816 8.48486 10.2083 8.48486V5.48486C7.12474 5.48486 4.625 7.98461 4.625 11.0682H7.625ZM7.14583 11.6099C7.41047 11.6099 7.625 11.8244 7.625 12.089L4.625 12.089C4.625 13.4812 5.75361 14.6099 7.14583 14.6099L7.14583 11.6099Z"
              fill="#003F2E"
            />
          </svg>
        </div>
        <div class="c-card__details">
          <h3 class="c-card__title">
            <a :href="result.url">
              {{ result.title }}
            </a>
          </h3>

          <div class="c-card__description u-content">
            {{ result.description }}
          </div>

          <div class="c-card__date">{{ result.date }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    result: Object,
  },
  components: {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss"></style>
